// Purpose: derive the 12-byte GCM nonce for a given chunk index.
// See docs/CRYPTO_FORMAT.md §4.

import { FILE_SALT_BYTES, NONCE_BYTES } from './constants.js';

export function buildNonce(salt: Uint8Array, chunkIndex: bigint): Uint8Array {
  if (salt.length !== FILE_SALT_BYTES) {
    throw new Error(`crypto-web.nonce: salt must be ${FILE_SALT_BYTES} bytes`);
  }
  if (chunkIndex < 0n) {
    throw new Error('crypto-web.nonce: chunk index must be non-negative');
  }
  const nonce = new Uint8Array(NONCE_BYTES);
  nonce.set(salt, 0);
  // Big-endian uint64 write.
  const view = new DataView(nonce.buffer, nonce.byteOffset + FILE_SALT_BYTES, 8);
  view.setBigUint64(0, chunkIndex, false);
  return nonce;
}
